export const routesList = {
    routeTypes: ["full", "popular"],
    routes: [
        {
            id: "Hamburg",
            searchText: "Hamburg Marathon",
            title: "Hamburg",
            subtitle: "Marathon",
            tagline: "3:45:01",
            routeType: "full",
            fileName: "Hamburg.json"
        },
        {
            id: "Munchen",
            searchText: "Munchen Marathon",
            title: "Munchen",
            subtitle: "Marathon",
            tagline: "3:30:03",
            routeType: "full",
            fileName: "Munchen.json"
        },
        {
            id: "Berlin",
            searchText: "Berlin Marathon",
            title: "Berlin",
            subtitle: "2017",
            tagline: "3:30:03",
            routeType: "full",
            fileName: "Berlin.json"
        },
        {
            id: "Paris",
            searchText: "Paris marathon",
            title: "Paris",
            subtitle: "Marathon",
            tagline: "3:30:03",
            routeType: "full",
            fileName: "Paris.json"
        },
        {
            id: "Rome",
            searchText: "Rome Marathon",
            title: "Rome",
            subtitle: "Marathon",
            tagline: "3:30:03",
            routeType: "full",
            fileName: "Rome.json"
        },
        {
            id: "Prag",
            searchText: "Prag Marathon",
            title: "Prag Marathon",
            subtitle: "3:42:11",
            tagline: "2021",
            routeType: "full",
            fileName: "Prag.json"
        },
        {
            id: "Vienna",
            searchText: "Vienna City Marathon",
            title: "Vienna City Marathon",
            subtitle: "3:01:15",
            tagline: "2021",
            routeType: "full",
            fileName: "Vienna.json"
        },
        {
            id: "Warschau",
            searchText: "Warschau Marathon",
            title: "Warschau",
            subtitle: "2016",
            tagline: "03:20:10",
            routeType: "full",
            fileName: "Warschau.json"
        },
        {
            id: "Budapest",
            searchText: "Budapest Marathon",
            title: "Budapest",
            subtitle: "2015",
            tagline: "03:20:10",
            routeType: "full",
            fileName: "Budapest.json"
        },
        {
            id: "NewYork",
            searchText: "New York Marathon",
            title: "New York",
            subtitle: "3:22:56",
            tagline: "2021",
            routeType: "full",
            fileName: "NewYork.json"
        },
        {
            id: "Boston",
            searchText: "Boston Marathon",
            title: "Boston 1991",
            subtitle: "3:01:14",
            tagline: "2021",
            routeType: "full",
            fileName: "Boston.json"
        },
        {
            id: "CaminoDeSantiago",
            searchText: "Camino de Santiago: 761 km",
            title: "Camino de Santiago",
            tagline: "2000",
            subtitle: "761 km",
            routeType: "popular",
            fileName: "StJeanSantiagodeCompostela.json"
        },
        {
            id: "PennineWay",
            searchText: "Pennine Way: 431.3 km",
            title: "Pennine Way",
            subtitle: "431.3 km",
            tagline: "2010",
            routeType: "popular",
            fileName: "PennineWay.json"
        },
        {
            id: "Munchen-Isar",
            searchText: "Munchen-Isar - Wandertag 10 km",
            title: "Munchen-Isar",
            subtitle: "10 km",
            tagline: "2015",
            routeType: "popular",
            fileName: "Munchen-Isar.json"
        },
        {
            id: "Lechweg",
            searchText: "Lechweg: 125 km",
            title: "Lechweg",
            tagline: "2017",
            subtitle: "125 km",
            routeType: "popular",
            fileName: "Lechweg.json"
        }

    ]
};